export const reviews = [
    { 
        id: 0, 
        name: 'Mariana Gutiérrez',
        description: 'Me ayudaron a resolver un contrato comercial complicado con rapidez y profesionalismo. Sentí seguridad en cada paso del proceso.',
        profesion: "Comerciante",
        city: "Rosario"
    },
    { 
        id: 1, 
        name: 'Ricardo López',
        description: 'Durante la sucesión de la familia me guiaron con mucha claridad y empatía. Logramos cerrar todo sin conflictos innecesarios.',
        profesion: "Jubilado",
        city: "Córdoba"
    },
    { 
        id: 2, 
        name: 'Sofía Ramírez',
        description: 'El acompañamiento en mi divorcio fue fundamental. No solo resolvieron lo legal, también me transmitieron tranquilidad en un momento difícil.',
        profesion: "Diseñadora gráfica",
        city: "Buenos Aires"
    },
    { 
        id: 3, 
        name: 'Martín Fernández',
        description: 'Necesitaba contratos para mis proveedores y clientes. El estudio preparó todo a medida, con una visión práctica y clara.',
        profesion: "Emprendedor",
        city: "Santa Fe"
    },
    { 
        id: 4, 
        name: 'Laura Pérez',
        description: 'Excelente atención, siempre atentos a mis consultas y con explicaciones sencillas. Se nota la experiencia en cada recomendación.',
        profesion: "Docente",
        city: "Entre Ríos"
    },
    { 
        id: 5, 
        name: 'Carlos Medina',
        description: 'Representaron a mi cliente en una ejecución y lograron cobrar lo adeudado en mucho menos tiempo de lo esperado. Muy eficientes.',
        profesion: "Contador",
        city: "Mendoza"
    },
    { 
        id: 6, 
        name: 'Julieta Torres',
        description: 'Tenía muchas dudas sobre un contrato de alquiler. Me orientaron de forma clara y evitaron que firmara algo desfavorable.',
        profesion: "Estudiante universitaria",
        city: "Córdoba"
    },
    { 
        id: 7,
        name: 'Hernán Rivas',
        description: 'Un estudio con gran compromiso. Se involucran de verdad en los casos y ofrecen soluciones concretas, no vueltas innecesarias.',
        profesion: "Empresario PyME",
        city: "Buenos Aires"
    },
    { 
        id: 8, 
        name: 'Natalia Domínguez',
        description: 'Conozco el medio y sé valorar el nivel de trabajo. El equipo de este estudio combina seriedad, estrategia y trato humano',
        profesion: "Abogada",
        city: "Rosario"
    }
];